import React, { useCallback, MouseEvent } from 'react';
import { NavigationLink as NavigationLinkType } from '../../../../types';
import Lazy from '../../../../components/lazy';

import * as S from './styles';

type Props = {
  link: NavigationLinkType;
  visible: boolean;
  selected: boolean;
  lazyLoadImage?: boolean;
  Component: React.ComponentType<S.ListItemProps>;
  onClick: (link: NavigationLinkType) => void;
};

const NavigationLink = ({
  link,
  visible,
  selected,
  Component,
  onClick,
  lazyLoadImage = true,
}: Props) => {
  const onClickHandler = useCallback(
    (e: MouseEvent) => {
      // Help google with a-links, but handle filter updates via actions
      e.preventDefault();

      onClick(link);
    },
    [link, onClick]
  );
  const image = link.productMedia?.first || link.fallbackImage;
  return (
    <Component visible={visible} selected={selected} data-test="NavigationLink">
      <S.ListItemLink
        to={(link.indexable && link.path) || undefined}
        onClick={onClickHandler}
        isExternal={false} // TODO: Remove when Clickable is refactored to TypeScript
      >
        <S.ListItemImage>
          {typeof image === 'string' &&
            (lazyLoadImage ? (
              <Lazy offset={0}>
                <img src={image} alt={link.value} />
              </Lazy>
            ) : (
              <img src={image} alt={link.value} />
            ))}
        </S.ListItemImage>
        <S.ListItemText>
          <S.LimitedTextField>{link.value}</S.LimitedTextField>
        </S.ListItemText>
      </S.ListItemLink>
    </Component>
  );
};

export default NavigationLink;
